/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AppConfigResource } from '../models/AppConfigResource'
import type { AppConfigStore } from '../models/AppConfigStore'
import type { AppConfigWrite } from '../models/AppConfigWrite'
import type { paginationLinks } from '../models/paginationLinks'
import type { paginationMeta } from '../models/paginationMeta'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class AppConfigService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List all app config items.
     * @returns any OK
     * @throws ApiError
     */
    public listAppConfig({
        page
    }: {
        /**
         * The page to retrieve starting with page 1.
         */
        page?: number
    }): CancelablePromise<{
        data: Array<AppConfigResource>
        meta: paginationMeta
        links: paginationLinks
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config',
            query: {
                page: page
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create a new app config.
     * @returns any Created
     * @throws ApiError
     */
    public createAppConfig({
        requestBody
    }: {
        /**
         * The app config to create
         */
        requestBody: AppConfigStore
    }): CancelablePromise<{
        data: AppConfigResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/config',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Get a specific app config.
     * @returns any OK
     * @throws ApiError
     */
    public getAppConfig({
        appConfig
    }: {
        /**
         * The key of the app config to get
         */
        appConfig: string
    }): CancelablePromise<{
        data: AppConfigResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/config/{appConfig}',
            path: {
                appConfig: appConfig
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a specific app config.
     * @returns void
     * @throws ApiError
     */
    public deleteAppConfig({
        appConfig
    }: {
        /**
         * The key of the app config to delete
         */
        appConfig: string
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/config/{appConfig}',
            path: {
                appConfig: appConfig
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update a specific app config.
     * @returns any OK
     * @throws ApiError
     */
    public updateAppConfig({
        appConfig,
        requestBody
    }: {
        /**
         * The key of the app config to update
         */
        appConfig: string
        /**
         * The app config to update
         */
        requestBody: AppConfigWrite & {
            /**
             * When set, Schedule an update. Otherwise, apply change immediately. Will return empty content if set.
             */
            change_at?: string | null
        }
    }): CancelablePromise<{
        data: AppConfigResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/config/{appConfig}',
            path: {
                appConfig: appConfig
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
